// components/ModalAddEvent.jsx
import { useState } from "react";
import Swal from "sweetalert2";

export default function ModalAddBank({ isOpen, onClose, onAdded }) {
  const [bankBank, setBankBank] = useState("");
  const [bankAtasNama, setBankAtasNama] = useState("");
  const [bankNoRek, setBankNoRek] = useState("");
  const [bankCabang, setBankCabang] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!bankNoRek.trim()) {
      Swal.fire("Peringatan", "Nomor rekening wajib diisi!", "warning");
      return;
    }

    const data = {
      bank: bankBank,
      atas_nama: bankAtasNama,
      no_rek: bankNoRek,
      cabang: bankCabang, // pastikan status berupa angka
    };

    try {

      // cek dulu apakah no_rek sudah ada
      const checkResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/bank/show?query=${bankNoRek}`
      );

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/bank/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        Swal.fire("Gagal", "Nomor rekening sudah terdaftar!", "error");
        return;
      }

      const resData = await response.json();

      if (resData && resData.id) {
        onAdded(resData); 
      }
        Swal.fire('Berhasil', 'Akun Bank berhasil ditambahkan.', 'success');
        setBankAtasNama("");
        setBankBank("");
        setBankNoRek("");
        setBankCabang("");
        onClose();
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-lg font-semibold mb-4">Tambah Akun Bank </h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            required
            className="w-full border p-2 rounded mb-4"
            placeholder="Nama Bank (ex: BCA, Mandiri)"
            value={bankBank}
            onChange={(e) => setBankBank(e.target.value)}
          />
          <input
            type="text"
            required
            className="w-full border p-2 rounded mb-4"
            placeholder="Nomor Rekening"
            value={bankNoRek}
            onChange={(e) => setBankNoRek(e.target.value)}
          />
          <input
            type="text"
            className="w-full border p-2 rounded mb-4"
            placeholder="Atas Nama"
            value={bankAtasNama}
            onChange={(e) => setBankAtasNama(e.target.value)}
          />
          <input
            type="text"
            required
            className="w-full border p-2 rounded mb-4"
            placeholder="Cabang"
            value={bankCabang}
            onChange={(e) => setBankCabang(e.target.value)}
          />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="text-gray-500">Batal</button>
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
